let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gSgrR")).then(() => parcelRequire('hPnJ8'));